import React, { useState, useCallback } from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { useMutation } from 'react-apollo-hooks';
import gql from 'graphql-tag';

import auth from '../utils/auth';

import Icon, {
  HomeIcon,
  ClipboardIcon,
  ChatIcon,
  QuoteIcon,
  StarIcon,
  ArchiveIcon,
  TagIcon,
  MicIcon
} from '../utils/icons';

const MainNavigation = () => (
  <nav>
    <NavLink className="nav-item" exact to="/">
      <div className="nav-item-icon">
        <Icon size={18} icon={HomeIcon} />
      </div>
      <div className="nav-item-title">Etusivu</div>
    </NavLink>
    <div className="nav-item-header">
      <div className="nav-item-header-title">Logit</div>
    </div>
    <NavLink className="nav-item-sub-item" to="/chats/new">
      <div className="nav-item-sub-item-icon">
        <Icon size={18} icon={StarIcon} />
      </div>
      <div className="nav-item-sub-item-title">Uudet</div>
    </NavLink>
    <NavLink className="nav-item-sub-item" to="/chats/analysed">
      <div className="nav-item-sub-item-icon">
        <Icon size={18} icon={ClipboardIcon} />
      </div>
      <div className="nav-item-sub-item-title">Opetettavat</div>
    </NavLink>
    <NavLink className="nav-item-sub-item" to="/chats/archived">
      <div className="nav-item-sub-item-icon">
        <Icon size={18} icon={ArchiveIcon} />
      </div>
      <div className="nav-item-sub-item-title">Arkistoidut</div>
    </NavLink>
    <div className="nav-item-header">
      <div className="nav-item-header-title">Opetus</div>
    </div>
    <NavLink className="nav-item" to="/qa">
      <div className="nav-item-icon">
        <Icon size={18} icon={QuoteIcon} />
      </div>
      <div className="nav-item-title">Q&A</div>
    </NavLink>
    <NavLink className="nav-item" to="/tags">
      <div className="nav-item-icon">
        <Icon size={18} icon={TagIcon} />
      </div>
      <div className="nav-item-title">Tagit</div>
    </NavLink>
    <NavLink className="nav-item" to="/acts">
      <div className="nav-item-icon">
        <Icon size={18} icon={MicIcon} />
      </div>
      <div className="nav-item-title">Speech Actit</div>
    </NavLink>
  </nav>
);

export default MainNavigation;
